import { createAction } from '@reduxjs/toolkit'

export const ON_LOGOUT = 'root/logout'
export const onLogout = createAction(ON_LOGOUT)
